import { render } from "./WsIndex.vue?vue&type=template&id=3a5b9e38"
import script from "./WsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WsIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Tools/WsIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a5b9e38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a5b9e38', __exports__)) {
    api.reload('3a5b9e38', __exports__)
  }
  
  module.hot.accept("./WsIndex.vue?vue&type=template&id=3a5b9e38", () => {
    api.rerender('3a5b9e38', render)
  })

}


export default __exports__